













































































import Vue from 'vue';
import massClient from '../../apis';
import moment from 'moment';

const coupon: any | null = null;
const selectIndexs: object[] | null = null;

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    oldCoupon: {
      type: Object,
      default: null,
    },
    scene: {
      type: String,
      default: null,
    },
    isWeixin: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.showCouponBox = this.show;
    this.loadCoupons();
  },
  data() {
    return {
      showCouponBox: false,
      current: 1,
      total: 0,
      pageSize: 10,
      coupon,
      loadCouponsFinished: false,
      couponId: null,
      coupons: [],
      selectIndexs,
    };
  },
  methods: {
    changePage(page: number) {
      if (this.current !== page) {
        this.current = page;
        this.loadCoupons();
      }
    },
    getDate(timestamp: number) {
      return moment.unix(timestamp).format('YYYY-MM-DD');
    },
    selectCoupon(item: any, index: number) {
      this.coupon = item;
      this.couponId = item.id;
      this.selectIndexs = this.coupons.map((e, index) => ({index: index, flag: false}));
      this.selectIndexs[index] = {index: index, flag: true};
    },
    loadCoupons() {
      this.loadCouponsFinished = false;
      massClient.getCoupons({
        page: this.current,
        size: this.pageSize,
        scene: this.scene,
        isWeixin: this.isWeixin,
      }).success((r) => {
        this.coupons = r.data;
        this.selectIndexs = this.coupons.map((e , index) => ({index: index, flag: false}));
        this.total = r.total;
        this.loadCouponsFinished = true;
      }).error((r) => {
        // console.log(r);
        // console.log('服务器错误，请刷新页面重试');
      });
    },
    close() {
      this.$emit('close');
    },
    confirmCoupon() {
      this.$emit('confirm', this.coupon);
    },
  },
  watch: {
    show() {
      this.showCouponBox = this.show;
    },
  },
});
